import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router      = inject(Router);

  if (authService.isAuthenticated()) {
    if (authService.permissionsLoaded() && authService.allowedModules().length === 0) {
      return true;
    }
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
